'use strict';

const progress = require('../../progress');
const util = require('../util');

const currentRequests = [];

/**
 * @function
 * @description ajax request to load html response in a given container
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 * @param {Object} target Selector or element that will receive content
 * @param {Boolean} replaceTarget If true, the target element will be completely replaced with new content
 */
const postForm = (options) => {
    options.url = options.form.attr('action');
    if (!options.url || currentRequests[options.url]) {
        return;
    }

    let data = options.form.serialize();

    if (options.triggeredAction){
        // add form action to data
        data += '&' + options.triggeredAction + '=' + options.triggeredAction;
    }

    // make sure the server knows this is an ajax request
    if (data.indexOf('ajax') === -1) {
        data += '&format=ajax';
    }

    // make the server call
    $.ajax({
        type: 'POST',
        url: util.appendParamToURL(options.url, 'format', 'ajax'),
        data: data
    })
    .done(function (response) {
        if (typeof response === 'object'){
            if (!response.success && response.error === 'CSRF Token Mismatch'){
                //TOOD : handle CSRF Token Mismatch on ajax
                if (options.handleCsrfMismatch && $.isFunction(options.handleCsrfMismatch)){
                    options.handleCsrfMismatch();
                    return;
                }
                location.reload();
                return;
            }
            options.handleJson(response);
            return;
        }

        if (options.target) {
            if (options.replaceTarget) {
                $(options.target).replaceWith(response);
            } else {
                $(options.target).empty().html(response);
            }
        }
        if (options.callback && $.isFunction(options.callback)) {
            options.callback(response);
        }
    })
    .fail(function (xhr, textStatus) {
        if (options.handleError && $.isFunction(options.handleError)) {
            options.handleError(textStatus);
        }
    })
    .always(function () {
        progress.hide();
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    });
};

module.exports = postForm;
